import React from 'react'

const index = () => {
  return (
    <div>Saved</div>
  )
}

export default index